import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi } from "../services/api";
import { useAuthStore } from "../stores/authStore";

export default function Dashboard() {
  const { hasPermission } = useAuthStore();
  const navigate = useNavigate();
  const [metrics, setMetrics] = useState<Record<string, any> | null>(null);
  const [audit,   setAudit]   = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetches: Promise<any>[] = [];
    if (hasPermission("metrics:read")) {
      fetches.push(adminApi.getMetrics().then(setMetrics).catch(() => {}));
      fetches.push(adminApi.listAudit({ limit: 5 }).then((r) => setAudit(r.entries)).catch(() => {}));
    }
    Promise.allSettled(fetches).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ color: "var(--text-muted)" }}>Loading…</div>;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <h1 style={{ fontSize: 20, fontWeight: 900 }}>📊 Dashboard</h1>

      {metrics && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12 }}>
          {[
            { label: "Total Families",  value: metrics.totalFamilies,    color: "#a5b4fc" },
            { label: "Active 7 days",   value: metrics.activeSevenDays,   color: "#86efac" },
            { label: "Quests Done",     value: metrics.totalCompletions,  color: "#fcd34d" },
            { label: "Stars Earned",    value: metrics.totalStarsEarned,  color: "#f9a8d4" },
          ].map((s) => (
            <div key={s.label} className="card">
              <div style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: ".07em", marginBottom: 6 }}>{s.label}</div>
              <div style={{ fontSize: 26, fontWeight: 900, color: s.color }}>{s.value?.toLocaleString() ?? "—"}</div>
            </div>
          ))}
        </div>
      )}

      {!hasPermission("metrics:read") && (
        <div className="card" style={{ color: "var(--text-muted)", textAlign: "center", padding: 32 }}>
          Dashboard metrics require metrics:read permission.
        </div>
      )}

      {audit.length > 0 && (
        <div className="card">
          <div style={{ fontWeight: 800, marginBottom: 12 }}>Recent Activity</div>
          {audit.map((e) => (
            <div key={e.auditId} style={{ display: "flex", gap: 12, padding: "8px 0", borderTop: "1px solid var(--border)", fontSize: 12 }}>
              <span style={{ color: "var(--text-muted)", minWidth: 140, fontFamily: "monospace", fontSize: 11 }}>
                {new Date(e.createdAt).toLocaleString()}
              </span>
              <span style={{ fontFamily: "monospace" }}>{e.action}</span>
              <span style={{ color: "var(--text-muted)", flex: 1 }}>{e.actorRole} · {e.actorId?.slice(0, 8)}</span>
            </div>
          ))}
          <button className="btn" style={{ marginTop: 12, fontSize: 12 }} onClick={() => navigate("/audit")}>View all →</button>
        </div>
      )}
    </div>
  );
}
